import React from "react";
// import { DatePicker } from "@digitallabs/one-x-ui";
import { DatePicker } from "../../../resourses/digitallabs/one-x-ui";
import * as intlDate from "@internationalized/date";

//  Convert DatePicker object → "DD/MM/YYYY"
const formatToDDMMYYYY = (date) => {
  if (!date) return "";

  const dd = String(date.day).padStart(2, "0");
  const mm = String(date.month).padStart(2, "0");

  return `${dd}/${mm}/${date.year}`;
};

//  Convert "DD/MM/YYYY" → DatePicker-compatible object
const parseFromDDMMYYYY = (value) => {
  if (!value || typeof value !== "string") return [];

  const parts = value.split("/");
  if (parts.length !== 3) return [];

  const [day, month, year] = parts;

  if (!day || !month || !year) return [];

  try {
    // 👉 MUST be YYYY-MM-DD
    const parsed = intlDate.parseDate(`${year}-${month}-${day}`);
    return [parsed];
  } catch (e) {
    return [];
  }
};

const DynamicDatepicker = ({
  field,
  fieldName,
  value,
  isMain,
  fieldRefs,
  updateValue,
  renderLabelWithPrefix,
  fieldIsRequired,
  validateSingleField,
  setErrors,
  submitted,
  errors,
}) => {
  //  Rebind value safely
  const parsedValue = parseFromDDMMYYYY(value);

  const isFutureDateDisallowed = field.rules.includes("future_date_disabled") ? true : false;
  const today = intlDate.today(intlDate.getLocalTimeZone());

  return (
    <div ref={fieldRefs.current[fieldName]} style={{ width: "100%" }}>
      <DatePicker
        placeholder="DD/MM/YYYY"
        selectionMode="single"
        value={parsedValue}
        max={isFutureDateDisallowed ? today : undefined}
        label={{
          label: renderLabelWithPrefix(isMain, field.question),
          optional: !fieldIsRequired(field),
        }}
        //  Display format
        format={(date) => formatToDDMMYYYY(date)}
        onValueChange={(details) => {
          const selectedDate = details.value?.[0];

          if (!selectedDate) {
            updateValue(fieldName, "");
            return;
          }

          //  Convert to string before storing
          const formatted = formatToDDMMYYYY(selectedDate);

          updateValue(fieldName, formatted);

          //  Validation
          const err = validateSingleField(field);
          setErrors((prev) => ({
            ...prev,
            ...err,
          }));
        }}
        helperText={{
          message: submitted && errors[fieldName] ? errors[fieldName] : "",
          status: submitted && errors[fieldName] ? "error" : "default",
        }}
      />
    </div>
  );
};

export default DynamicDatepicker;
